/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 40);
/******/ })
/************************************************************************/
/******/ ({

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// var angular = require('node_modules/angular/angular.js');

(function () {
    'use strict';

    angular.module('app').service('harbourService', harbourServiceFactory).service('vesselService', vesselServiceFactory).service('vesselPathService', vesselPathServiceFactory).service('cargoService', cargoServiceFactory).service('markerService', markerServiceFactory).service('openWeatherMapDataService', openWeatherMapDataService).service('emissionControlAreaService', emissionControlAreaServiceFactory);

    emissionControlAreaServiceFactory.$inject = ['$http', 'apiBaseUrl'];
    function emissionControlAreaServiceFactory($http, apiUrl) {
        var path = apiUrl + 'assets/content/json/eca.geo.json';
        this.getEmissionControlAreas = function () {
            return $http.get(path).then(function (response) {
                return response.data;
            });
        };
    }

    harbourServiceFactory.$inject = ['$http', '$sessionStorage', 'apiBaseUrl'];
    function harbourServiceFactory($http, $sessionStorage, apiUrl) {
        var companyCode = $sessionStorage.logonInfo.agency.companyCode;
        var path = apiUrl + 'api/harbour/HarboursDataService.asmx/GetHarboursByCompany';
        this.getHarbours = function () {
            return $http.post(path, { company: companyCode }, { responseType: 'json' }).then(function (resp) {
                return resp.data;
            });
        };
    }

    vesselServiceFactory.$inject = ['$http', '$sessionStorage', 'apiBaseUrl'];
    function vesselServiceFactory($http, $sessionStorage, apiUrl) {
        var storage = $sessionStorage;
        var vesselsHavingWaypointsPath = apiUrl + 'api/vessel/VesselsHavingWaypointsService.asmx/GetVesselsByCompany';
        this.getVesselsHavingWaypoints = function () {
            return $http.post(vesselsHavingWaypointsPath, { companyCode: storage.logonInfo.agency.companyCode }, { responseType: 'json' }).then(function (resp) {
                return resp.data;
            });
        };
        var markerPath = apiUrl + 'api/vessel/AisData.asmx/GetAisDataForAllVessels';
        this.getVesselMarkers = function () {
            return $http.post(markerPath, { companyCode: storage.logonInfo.agency.companyCode }, { responseType: 'json' }).then(function (resp) {
                return resp.data;
            });
        };

        var historicalMarkerPath = apiUrl + 'api/vessel/AisData.asmx/GetHistoricalAisDataForAllVessels';
        this.getHistoricalVesselMarkers = function (historyItems) {
            return $http.post(historicalMarkerPath, { companyCode: storage.logonInfo.agency.companyCode, historyItems: historyItems }, { responseType: 'json' }).then(function (resp) {
                return resp.data;
            });
        };

        var pointsPath = apiUrl + 'api/vessel/TrackPointService.asmx/GetVesselPath';
        this.getVesselPath = function (vesselCode, timeInHours) {
            return $http.post(pointsPath, { companyCode: storage.logonInfo.agency.companyCode, vesselCode: vesselCode, timeInHours: timeInHours }, { responseType: 'json' }).then(function (resp) {
                return resp.data;
            });
        };

        var vesselPointsPath = apiUrl + 'api/vessel/TrackPointService.asmx/GetHistoricalVesselPaths';
        this.getHistoricalVesselPaths = function (historyItems) {
            return $http.post(vesselPointsPath, { companyCode: storage.logonInfo.agency.companyCode, historyItems: historyItems }, { responseType: 'json' }).then(function (resp) {
                return resp.data;
            });
        };

        var vesselInfoPath = apiUrl + 'api/vessel/VesselDetailInfoService.asmx/GetVesselDetailInfoService';
        this.getVesselDetails = function (vesselCode, lastReportDate) {
            var security = storage.logonInfo.security;
            var userRoles = security ? security.roles : [];
            return $http.post(vesselInfoPath, { companyCode: storage.logonInfo.agency.companyCode, vesselCode: vesselCode, userRoles: userRoles, lastReportDate: lastReportDate }, { responseType: 'json' }).then(function (resp) {
                return resp.data;
            });
        };

        var currentVoyagesByVesselPath = apiUrl + 'api/vessel/CurrentVoyagesByVesselService.asmx/GetByCompanyAndVessel';
        this.getCurrentVoyages = function (vesselCode, searchValue) {
            return $http.post(currentVoyagesByVesselPath, { companyCode: storage.logonInfo.agency.companyCode, vesselCode: vesselCode, searchValue: searchValue }, { responseType: 'json' }).then(function (resp) {
                return resp.data.d;
            });
        };

        var bunkerConsumptionPath = apiUrl + 'api/vessel/VesselDetailInfoService.asmx/GetDataForCalculation';
        this.getBunkerConsumption = function (vesselCode, aisPodLocation, speed) {
            return $http.post(bunkerConsumptionPath, { companyCode: storage.logonInfo.agency.companyCode, vesselCode: vesselCode, aisPodLocation: aisPodLocation || 'n/a', speedString: speed || '0' }, { responseType: 'json' }).then(function (resp) {
                return resp.data;
            });
        };
    }

    cargoServiceFactory.$inject = ['$http', '$sessionStorage', 'apiBaseUrl'];
    function cargoServiceFactory($http, $sessionStorage, apiUrl) {
        var companyCode = $sessionStorage.logonInfo.agency.companyCode;
        var path = apiUrl + 'api/cargo/CargoService.asmx/GetCargoDataForVoyage';
        this.getCargoInfo = function (vesselCode, nextPortId) {
            return $http.post(path, { companyCode: companyCode, vesselCode: vesselCode, nextPortId: nextPortId }, { responseType: 'json' }).then(function (resp) {
                return resp.data;
            });
        };
    }

    openWeatherMapDataService.$inject = ['$http'];
    function openWeatherMapDataService($http) {
        var pathFind = 'https://api.openweathermap.org/data/2.5/find';
        this.getByPoint = function (lat, lon, count, apiKey) {
            return $http.get(pathFind, {
                params: { lat: lat, lon: lon, count: count, apiKey: apiKey }
            }, { responseType: 'json' }).then(function (resp) {
                return resp.data;
            });
        };

        //  [lon-left,lat-bottom,lon-right,lat-top,zoom]
        var pathCity = 'https://api.openweathermap.org/data/2.5/box/city';
        this.getByBoundsAndZoom = function (bounds, zoom, apiKey) {
            var list = [bounds._southWest.lng, bounds._southWest.lat, bounds._northEast.lng, bounds._northEast.lat, zoom];
            var bbox = list.join(',');
            return $http.get(pathCity, {
                params: { bbox: bbox, apiKey: apiKey }
            }, { responseType: 'json' }).then(function (resp) {
                return resp.data;
            });
        };
    }

    vesselPathServiceFactory.$inject = ['vesselService', '$interpolate'];
    function vesselPathServiceFactory(vesselService, $interpolate) {
        // load vessel (marker.modelName) path points using web service
        this.getPath = function (vesselCode, hoursInPast) {
            return vesselService.getVesselPath(vesselCode, hoursInPast).then(function (data) {
                var paths = {};
                var points = data.d.points;
                var i = 0;
                var lastPoint;
                points.map(function (point) {
                    var tooltipHtml = $interpolate('<span>{{ Speed }} knots&nbsp;/&nbsp; {{ Cours }} &deg;</span>' + '<br/><span>{{ TimeStamp }}</span>');
                    var currentPoint = {
                        lat: parseFloat(point.Lat.replace(',', '.')),
                        lng: parseFloat(point.Lon.replace(',', '.'))
                    };
                    if (lastPoint) {
                        paths['Point' + i++] = {
                            color: 'blueviolet',
                            weight: 2,
                            latlngs: [lastPoint, currentPoint],
                            vessel: vesselCode
                        };
                    }
                    lastPoint = currentPoint;
                    paths['Point' + i++] = {
                        type: "circleMarker",
                        radius: 1,
                        latlngs: currentPoint,
                        tooltip: tooltipHtml(point),
                        vessel: vesselCode
                    };
                });
                return paths;
            });
        };
    }

    markerServiceFactory.$inject = ['harbourService', 'vesselService', '$interpolate', '$document', 'openWeatherMapDataService', '$q'];
    function markerServiceFactory(harbourService, vesselService, $interpolate, $document, openWeatherMapDataService, $q) {
        var getMarkerBackGroundColor = function getMarkerBackGroundColor(aisInfo) {
            var backgroundColor = "#ffffff"; // white;
            var calcEta = aisInfo.CalcEta ? Date.parse(aisInfo.CalcEta.replace(/\.|-/g, "/")) : "n/a";
            var scheduleEta = aisInfo.ScheduleEta ? Date.parse(aisInfo.ScheduleEta.replace(/\.|-/g, "/")) : "n/a";

            // aisInfo.Status is written by observer service into dba.vessel_status.vs_status
            // https://support.softship.com/confluence/display/WES/Observer+Service#ObserverService-VSTAT–UpdateVesselStatus

            // Background color of vessel marker rendered at AIS position should be (base on vessel status):
            // 1: Sailing - calculated eta > planned eta then red otherwise green
            // 2: In Port / Cargo Operations - gray
            // 3: Sailing / Unknown - white
            // 4: Anchoring - blue
            // 5: Other Error - white
            // 6: Offhire - white - vessel cannot be found in current schedule
            // 
            // AIS has its own status: 0 = underway, 1 = at anchor, 5 = moored,  8 = underway by sail
            if (aisInfo.Status === '6') {
                backgroundColor = "#ffffff"; // white
            } else if (aisInfo.Status === '5') {
                backgroundColor = "#ffffff"; // white
            } else if (aisInfo.Status === '4') {
                backgroundColor = "#00ccff"; // blue
            } else if (aisInfo.Status === '3') {
                backgroundColor = "#ffffff"; // white
            } else if (aisInfo.Status === '2') {
                backgroundColor = "#cccccc"; // gray
            } else if (aisInfo.Status === '1') {
                // match: aisInfo.DestinationMatch = 3
                if (!aisInfo.DestinationMatch || aisInfo.DestinationMatch !== 3 || !calcEta || !scheduleEta) {
                    backgroundColor = "#ffffff"; // white -- we need matching destinations AND both values to be able to compare
                } else {
                    if (calcEta > scheduleEta) {
                        backgroundColor = "#FF6347"; // red -- arrival too late
                    } else {
                        backgroundColor = "#00ff00"; // lime (green) -- arrival in time
                    }
                }
            }

            return backgroundColor;
        };

        var harbourInfoStartHtml = $interpolate('<div class="harbourMarker">' + '<p><span><b>{{ Name }} ({{ Code }})</b></span></p>');
        var berthInfoHtml = $interpolate('<p/><p><span><b>{{ Name }}</b></span></p>' + '<p>&nbsp;&nbsp;Remarks: {{ Remarks }}</p>' + '<p>&nbsp;&nbsp;Opening hours: {{ OpeningHours }}</p>');
        var harbourInfoEndHtml = function harbourInfoEndHtml() {
            return '</div>';
        };

        var harbourIcon = {
            iconUrl: './assets/content/image/harbour.png',
            iconSize: [16, 16],
            iconAnchor: [8, 8]
        };

        // then vessel icon and text
        // load vessels using web service
        var vesselHtml = $interpolate("<p class='vesselMarker' style='background: {{ BackgroundColor }};'>" + "<a class='vesselMarkerName' href='javascript:void(0)'" + " onmouseover=\"softship.helpers.toggleDiv('{{ Code }}'); return false;\"" + " onmouseout=\"softship.helpers.toggleDiv('{{ Code }}'); return false;\">" + "{{ VesselName }}</a></p>" + "<div class='vesselMarker vesselMarkerPopup' id='{{ Code }}' style='background: {{ BackgroundColor }}; display:none;'>" + "<table>" + "<tr><td colspan='2'></td></tr>" + "<tr><td>Next Port ({{ Source }}):</td><td>{{ NextPortName.substring(0, 14) }}</td></tr>" + "<tr><td>ETA ({{ Source }}):</td><td>{{ Eta }}</td></tr>" + "<tr><td>Next Port (Schedule):</td><td>{{ ScheduleNextPortCode }}</td></tr>" + "<tr><td>ETA (Schedule):</td><td>{{ ScheduleEta }}</td></tr>" + "<tr><td>Voyage Number (Schedule):</td><td>{{ ScheduleVoyageNumber }}</td></tr>" + "<tr><td>ETB first berth (Schedule):</td><td>{{ ScheduleETB }}</td></tr>" + "<tr><td>Course:</td><td>{{ Course }}</td></tr>" + "<tr><td>Speed:</td><td>{{ Speed }}</td></tr>" + "<tr><td>Draft fwd (VR):</td><td>{{ VesselReportFWD }}</td></tr>" + "<tr><td>Draft aft (VR):</td><td>{{ VesselReportAFT }}</td></tr>" + "<tr><td>Draught max.:</td><td>{{ Draught }}</td></tr>" + "<tr><td>Received UTC ({{ Source }}):</td><td>{{ CreateDate }}</td></tr>" + "<tr><td colspan='2'></td></tr>" + "</table></div>");

        // svg vector graph
        var createVesselIcon = function createVesselIcon(color, angle) {
            var svg = "<svg xmlns='http://www.w3.org/2000/svg' x='0' y='0' height='26' width='26'><polyline points='6,23 6,15 12,1 18,16 18,23 12,18 6,23' style='fill:" + color + "; stroke: black; stroke-width: 1;' transform='rotate(" + angle + ",13,13)' /></svg>";
            var url = encodeURI("data:image/svg+xml," + svg).replace('#', '%23');
            var leafletIcon = {
                iconUrl: url,
                iconSize: [26, 26],
                iconAnchor: [13, 13]
            };
            return leafletIcon;
        };

        var normalizeId = function normalizeId(id) {
            return id.replace('-', '_').replace('+', '_').replace('.', '_').replace(',', '_');
        };

        var weatherMarkerHtml = $interpolate('<div class="weatherPopup"><p><h4><a href="https://openweathermap.org/city/{{id}}">{{name}}</a></h4></p>' + '<p><img class="weather_image" src="https://openweathermap.org/img/w/{{weather[0].icon}}.png"/>&nbsp&nbsp&nbsp<strong>{{weather[0].main}}</strong></p>' + '<p><span>Temperature: <strong>{{main.temp}}&deg;</strong></span><br/>' + '<span>Temperature min. /max.: <strong>{{main.temp_min | number}} &deg; / {{main.temp_max | number}} &deg;</strong></span><br/>' + '<span>Humidity: <strong>{{main.humidity | number}}%</strong></span><br/>' + '<span>Wind: <strong>{{wind.speed | number}} m/s</strong></span><br/>' + '<span ng-show="clouds.today">Clouds: <strong>{{clouds.today | number}}%</strong></span></p></div>');

        var createWeatherIcon = function createWeatherIcon(city) {
            return {
                iconUrl: 'https://openweathermap.org/img/w/' + city.weather[0].icon + '.png',
                iconSize: [36, 36],
                iconAnchor: [13, 13]
            };
        };

        this.createSummaryControl = function () {
            if (L.control.summary) return L.control.summary;

            L.Control.summary = L.Control.extend({
                onAdd: function onAdd(map) {
                    this._map = map;
                    // TODO: not elegant - $compile of html template (ng-include?)
                    this._sidebar = $document[0].getElementById('sidebar');
                    L.DomEvent.disableClickPropagation(this._sidebar);
                    L.DomEvent.disableScrollPropagation(this._sidebar);
                    return this._sidebar;
                },

                onRemove: function onRemove(map) {
                    // nop
                }
            });
            L.control.summary = function (opts) {
                return new L.Control.summary(opts);
            };

            return L.control.summary;
        };

        this.createTimestepControl = function () {
            if (L.control.timestep) return L.control.timestep;

            L.Control.timestep = L.Control.extend({
                onAdd: function onAdd(map) {
                    this._map = map;
                    this._timestep = $document[0].getElementById('timestep');
                    L.DomEvent.disableClickPropagation(this._timestep);
                    L.DomEvent.disableScrollPropagation(this._timestep);
                    return this._timestep;
                },

                onRemove: function onRemove(map) {
                    // nop
                }
            });
            L.control.timestep = function (opts) {
                return new L.Control.timestep(opts);
            };

            return L.control.timestep;
        };

        this.createTimeWaypointControl = function () {
            if (L.control.timeWaypoint) return L.control.timeWaypoint;

            L.Control.timeWaypoint = L.Control.extend({
                onAdd: function onAdd(map) {
                    this._map = map;
                    this._timeWaypoint = $document[0].getElementById('timeWaypoint');
                    L.DomEvent.disableClickPropagation(this._timeWaypoint);
                    L.DomEvent.disableScrollPropagation(this._timeWaypoint);
                    return this._timeWaypoint;
                },

                onRemove: function onRemove(map) {
                    // nop
                }
            });
            L.control.timeWaypoint = function (opts) {
                return new L.Control.timeWaypoint(opts);
            };

            return L.control.timeWaypoint;
        };

        this.createHistoryWaypointsControl = function () {
            if (L.control.historyWaypoints) return L.control.historyWaypoints;

            L.Control.historyWaypoints = L.Control.extend({
                onAdd: function onAdd(map) {
                    this._map = map;
                    this._historyWaypoints = $document[0].getElementById('historyWaypoints');
                    L.DomEvent.disableClickPropagation(this._historyWaypoints);
                    L.DomEvent.disableScrollPropagation(this._historyWaypoints);
                    return this._historyWaypoints;
                },

                onRemove: function onRemove(map) {
                    // nop
                }
            });
            L.control.historyWaypoints = function (opts) {
                return new L.Control.historyWaypoints(opts);
            };

            return L.control.historyWaypoints;
        };

        this.getHistoricalMarkersAndPaths = function (items) {
            return $q.all({
                harbourData: harbourService.getHarbours(),
                vesselData: vesselService.getHistoricalVesselMarkers(items),
                pathData: vesselService.getHistoricalVesselPaths(items)
            }).then(function (result) {
                var markers = {};
                var harbours = result.harbourData.d.harbours;
                // first load harbours
                harbours.map(function (harbour) {
                    if (!harbour.Code) return;

                    markers['Harbour' + harbour.Code] = {
                        layer: 'harbours',
                        lat: harbour.Lat,
                        lng: harbour.Lon,
                        icon: angular.copy(harbourIcon),
                        tooltip: harbourInfoStartHtml(harbour) + harbour.Berths.map(berthInfoHtml).join('') + harbourInfoEndHtml()
                    };
                });

                var vesselMarkers = result.vesselData.d;
                vesselMarkers.map(function (vessel) {
                    // cannnot show vessel without the coordinates
                    // filter only one vessel if MMSI passed by caller
                    if (!vessel.Code || !vessel.LAT || !vessel.LON) return;

                    // skip not selcted vessels
                    if (_.every(items, function (i) {
                        return i.vessel.code !== vessel.Code;
                    })) return;

                    angular.extend(vessel, { BackgroundColor: getMarkerBackGroundColor(vessel) });
                    var width = vessel.VesselName.length * 7 + 6;
                    markers['VesselArrow' + vessel.Code] = {
                        layer: 'vessels',
                        lat: parseFloat(vessel.LAT.replace(',', '.')),
                        lng: parseFloat(vessel.LON.replace(',', '.')),
                        icon: createVesselIcon(vessel.VesselIconCssColor || 'cornflowerblue', parseInt(vessel.Course)),
                        code: vessel.Code,
                        nextPortId: vessel.NextPortId,
                        zIndexOffset: 500,
                        opacity: 0.85,
                        showPath: true
                    };
                    markers['VesselLabel' + vessel.Code] = {
                        layer: 'vessels',
                        lat: parseFloat(vessel.LAT.replace(',', '.')),
                        lng: parseFloat(vessel.LON.replace(',', '.')),
                        icon: {
                            type: 'div',
                            className: 'vesselNameMarker',
                            iconSize: [width, 15],
                            iconAnchor: [width / 2, -12],
                            html: vesselHtml(vessel)
                        },
                        code: vessel.Code,
                        nextPortId: vessel.NextPortId,
                        lastReportDate: vessel.LastReportDate,
                        zIndexOffset: 600,
                        opacity: 0.85,
                        showPath: false,
                        riseOnHover: true
                    };
                });

                var paths = [];
                var vesselPaths = result.pathData.d;
                var i = 0;
                vesselPaths.map(function (item) {
                    var lastPoint;
                    item.points.map(function (point) {
                        var tooltipHtml = $interpolate('<span>Vessel: ' + item.vesselCode + '</span><br/>' + '<span>{{ Speed }} knots&nbsp;/&nbsp; {{ Cours }} &deg;</span><br/>' + '<br/><span>{{ TimeStamp }}</span>');
                        var currentPoint = {
                            lat: parseFloat(point.Lat.replace(',', '.')),
                            lng: parseFloat(point.Lon.replace(',', '.'))
                        };
                        if (currentPoint.lat && currentPoint.lng) {
                            if (lastPoint) {
                                paths.push({
                                    color: item.color,
                                    weight: 2,
                                    latlngs: [lastPoint, currentPoint],
                                    vessel: item.vesselCode
                                });
                            }
                            lastPoint = currentPoint;
                            paths.push({
                                type: "circleMarker",
                                color: item.color,
                                radius: 1,
                                latlngs: currentPoint,
                                tooltip: tooltipHtml(point),
                                vessel: item.vesselCode
                            });
                        }
                    });
                });

                return {
                    markers: markers,
                    paths: paths
                };
            });
        };

        this.getMarkers = function (bounds, zoom, mmsi, openWeatherMapApiKey, onlyWeatherMarkers) {
            return $q.all(!onlyWeatherMarkers ? {
                harbourData: harbourService.getHarbours(),
                vesselData: vesselService.getVesselMarkers(),
                weatherData: openWeatherMapApiKey ? openWeatherMapDataService.getByBoundsAndZoom(bounds, zoom, openWeatherMapApiKey) : null
            } : {
                weatherData: openWeatherMapApiKey ? openWeatherMapDataService.getByBoundsAndZoom(bounds, zoom, openWeatherMapApiKey) : null
            }).then(function (result) {

                var markers = {};

                if (result.weatherData && result.weatherData.cod === 200) {
                    var cities = result.weatherData.list;
                    cities.map(function (city) {
                        markers['Weather' + city.id] = {
                            layer: 'weather',
                            lat: parseFloat(city.coord.Lat),
                            lng: parseFloat(city.coord.Lon),
                            icon: createWeatherIcon(city),
                            message: weatherMarkerHtml(city)
                        };
                    });
                }

                if (onlyWeatherMarkers) return {
                    markers: markers
                };

                var harbours = result.harbourData.d.harbours;
                // first load harbours
                harbours.map(function (harbour) {
                    if (!harbour.Code) return;

                    markers['Harbour' + harbour.Code] = {
                        layer: 'harbours',
                        lat: harbour.Lat,
                        lng: harbour.Lon,
                        icon: angular.copy(harbourIcon),
                        tooltip: harbourInfoStartHtml(harbour) + harbour.Berths.map(berthInfoHtml).join('') + harbourInfoEndHtml()
                    };
                });

                var vesselMarkers = result.vesselData.d;
                vesselMarkers.map(function (vessel) {
                    // cannnot show vessel without the coordinates
                    // filter only one vessel if MMSI passed by caller
                    if (!vessel.Code || !vessel.LAT || !vessel.LON || mmsi && mmsi !== vessel.VesselMmsi) return;

                    angular.extend(vessel, { BackgroundColor: getMarkerBackGroundColor(vessel) });
                    var width = vessel.VesselName.length * 7 + 6;
                    markers[normalizeId('VesselArrow' + vessel.Code)] = {
                        layer: 'vessels',
                        lat: parseFloat(vessel.LAT.replace(',', '.')),
                        lng: parseFloat(vessel.LON.replace(',', '.')),
                        icon: createVesselIcon(vessel.VesselIconCssColor || 'cornflowerblue', parseInt(vessel.Course)),
                        code: vessel.Code,
                        nextPortId: vessel.NextPortId,
                        zIndexOffset: 500,
                        opacity: 0.85,
                        showPath: true
                    };
                    markers[normalizeId('VesselLabel' + vessel.Code)] = {
                        layer: 'vessels',
                        lat: parseFloat(vessel.LAT.replace(',', '.')),
                        lng: parseFloat(vessel.LON.replace(',', '.')),
                        icon: {
                            type: 'div',
                            className: 'vesselNameMarker',
                            iconSize: [width, 15],
                            iconAnchor: [width / 2, -12],
                            html: vesselHtml(vessel)
                        },
                        code: vessel.Code,
                        nextPortId: vessel.NextPortId,
                        lastReportDate: vessel.LastReportDate,
                        zIndexOffset: 600,
                        opacity: 0.85,
                        showPath: false,
                        riseOnHover: true
                    };
                });

                return {
                    markers: markers
                };
            });
        };
    }
})();

/***/ })

/******/ });


// WEBPACK FOOTER //
// service_f61149ed4534c2438558.js